import 'slick-carousel';
import Swiper from 'swiper';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// cookieセット
function setCookie() {
  var exp = new Date();
  exp.setTime(exp.getTime() + 365*24*60*60*1000); // 365日
  document.cookie = "access=on;expires=" + exp.toGMTString() + ";path=/;";
};

$(function () {
  var arr,reg = new RegExp("(^| )access=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg)) {
    /* 2回目以降アクセス時の処理 */
    $('.header__logo, .header__nav, .homeMv__newsBox, .fixedbanner').removeClass('is_hide');
    $('.wrapper').removeClass('is_opening');
    $('.homeMv').addClass('is_second');
    $('.homeMv__txtBox').addClass('is_second');
    jsMvSlider();
    jsAnimTrigger();
    jsFlowSlider();
    // 一瞬画背景像が見えてしまう対応
    $('.wrapper').addClass('is_lazyload');
	} else {
    /* 初回アクセス時の処理 */
    setCookie();
    var openingTl = gsap.timeline().add(() => {
      $('.homeMv__logo').addClass('is_blur');
    }).to(
      '.homeMv__skipBtn', { opacity: 1, duration: 1 }
    ).to(
      '.homeMv__logo', { duration: 4 }, '+='
    ).add(() => {
      $('.homeMv__txtBox').addClass('is_remove_blur');
    }).to(
      '.homeMv__txtBox', { duration: 2 }
    ).add(() => {
      $('.homeMv').addClass('is_clear_blur');
      $('.header__logo').removeClass('is_hide').addClass('is_appear');
    }).to(
      '.header__logo', { duration: 1 }
    ).add(() => {
      $('.header__nav').removeClass('is_hide').addClass('is_appear');
    }).to(
      '.header__nav', { duration: 1 }
    ).add(() => {
      $('.homeMv__newsBox').removeClass('is_hide').addClass('is_appear');
      $('.fixedbanner').removeClass('is_hide').addClass('is_appear');
    }).to(
      '.fixedbanner', { duration: 1 }
    ).to (
      '.homeMv__skipBtn',
      { opacity: 0, duration: 1 }, '<='
    ).set (
      '.homeMv__skipBtn',
      { zIndex: '-1', }
    ).add(() => {
      $('.wrapper').removeClass('is_opening');
      // 一瞬画背景像が見えてしまう対応
      $('.wrapper').addClass('is_lazyload');
      $('.homeMv').addClass('is_second');
      jsMvSlider();
      jsAnimTrigger();
      jsFlowSlider();
      jsServiceSliderFunc();
    });
  }

  // オープニングSKIP
  $('.js-mv-skip').on('click', function(){
    $('.homeMv__txtBox').addClass('is_remove_blur');
    gsap.timeline().to (
      '.homeMv__skipBtn',
      { opacity: 0, duration: 1 }
    ).set (
      '.homeMv__skipBtn',
      { zIndex: '-1', }
    )
    openingTl.seek(6);
  });
});

// TOPスライド
function jsMvSlider() {
  var jsMvSlider = $('.js-mv-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    autoplaySpeed: 3000,
    autoplay: true,
    speed: 2000,
    fade: true,
    dots: false,
    arrows: false,
  }).on({beforeChange: function(event, slick, currentSlide, nextSlide){
      $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
      $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
    },
    afterChange: function() {
      $(".preve-slide", this).removeClass("preve-slide slide-animation");
    }
  });
  jsMvSlider.find(".slick-slide").eq(0).addClass("slide-animation");

  var length = $('.js-mv-news-slider li').length;
  $('.homeMv__newsBox__num .is_total').html(length);
  var jsMvNewsSlider = $('.js-mv-news-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    autoplaySpeed: 4000,
    autoplay: true,
    speed: 1000,
    fade: true,
    dots: false,
    arrows: false,
  });
  $('.js-mv-news-slider li').addClass('is_anime');
  jsMvNewsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var num = nextSlide + 1;
    $('.homeMv__newsBox__num .is_current').html(num);
    $('.js-mv-news-slider li').eq(nextSlide).removeClass('is_anime');
  });
  jsMvNewsSlider.on('afterChange', function(event, slick, currentSlide){
    $('.js-mv-news-slider li').eq(currentSlide).addClass('is_anime');
  });
}

function jsAnimTrigger() {
  if($('.homeMv__slideList').length) {
    gsap.to('.homeMv__slideList', { // アニメーションさせたい要素
    filter: "blur(30px)",
    scrollTrigger: {
      trigger: '.wrapper', // アニメーションのトリガーとなる要素
      start: 'top 75%', // アニメーションが発火するタイミング
      end: "top top",
      scrub: true,
  //      markers: true
    }
  });
}

  if($('.homeSec02').length) {
    gsap.to('.homeMv__slideList__item', { // アニメーションさせたい要素
      opacity: 0,
      scrollTrigger: {
        trigger: '.homeSec02', // アニメーションのトリガーとなる要素
        start: 'top 75%', // アニメーションが発火するタイミング
        end: "top top",
        scrub: true,
        //  markers: true
      }
    });
  }

  ScrollTrigger.create({
    trigger: '.wrapper',
    start: 'top 0%',
    end: "bottom 0%",
    toggleClass: {targets: 'body', className: "is_active"},
    scrub: true,
    // markers: true,
  });
}

function jsFlowSlider() {
  $('.js-flow-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 100000,
    fade: false,
    dots: false,
    arrows: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 50000,
        },
      },
    ],
  });
  $('.js-flow-slider').on( 'lazyLoaded', function( evt ) {
    $(evt.currentTarget).find('source').each( function(i, source) {
      var $source = $(source);
      $source.attr('srcset', $source.data('lazy-srcset'));
    });
  });
}

$(window).on('load', function () {
  const slideLength = document.querySelectorAll('.js-news-slider .swiper-slide').length

  if (matchMedia('(max-width: 767px)').matches) {
    var slideMin = 1;
  } else {
    var slideMin = 2;
  }

  if(slideLength > slideMin) {
    const jsNewsSlider = new Swiper('.js-news-slider', {
      lazy: true,
      loop: true,
      slidesPerView: 'auto',
      breakpoints: {
        767: {
          width: 200,
          // freeMode: true,
        }
      },
    });
    $('.js-news-next').on('click', function() {
      jsNewsSlider.slideNext();
    });
    $('.js-news-prev').on('click', function() {
      jsNewsSlider.slidePrev();
    });
  } else {
    $('.homeSec03__btnList').css('display', 'none');
  }
});

$(window).on('load resize', function () {
  setTimeout(function(){
    jsServiceSliderFunc();
  }, 500);
});

let serviceSwiper;
var mySwiperBool = false;

function jsServiceSliderFunc() {
  if (matchMedia('(max-width: 767px)').matches) {
    if(mySwiperBool == false) {
      serviceSwiper = new Swiper('.js-service-slider', {
        // freeMode: true,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 20,
      });
      mySwiperBool = true;
    }
    $('.js-service-next').on('click', function() {
      serviceSwiper.slideNext();
    });
    $('.js-service-prev').on('click', function() {
      serviceSwiper.slidePrev();
    });
  } else {
    if($('.js-service-slider').hasClass('swiper-container-initialized') && mySwiperBool) {
      serviceSwiper.destroy(false, true);
      mySwiperBool = false;
    }
  }
  $('.js-service-matchheight').matchHeight();
}

$(window).on('load', function () {
  const jsCoachSlider = new Swiper('.js-coach-slider', {
    lazy: true,
    loop: true,
    slidesPerView: 'auto',
    width: 660,
    speed: 500,
    autoplay: {     //追記
      delay: 3500,   //追記
    },
    breakpoints: {
      767: {
        width: 222,
        // freeMode: true,
      }
    },
  });
  $('.js-coach-next').on('click', function() {
    jsCoachSlider.slideNext();
  });
  $('.js-coach-prev').on('click', function() {
    jsCoachSlider.slidePrev();
  });
});

$(window).on('load', function () {
  const jsStudentSlider = new Swiper('.js-student-slider', {
    lazy: true,
    loop: true,
    slidesPerView: 'auto',
    width: 660,
    breakpoints: {
      767: {
        width: 294,
        // freeMode: true,
      }
    },
  });
  $('.js-student-next').on('click', function() {
    jsStudentSlider.slideNext();
  });
  $('.js-student-prev').on('click', function() {
    jsStudentSlider.slidePrev();
  });
});

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.fade-up-in').forEach(wrap => {
  gsap.fromTo(wrap,
    {
      y: 100,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom',
        end: 'top 50%',
        scrub: true,
        // markers: true,
      }
    }
  )
});
